// src/context/brandVoice/widgets/index.js — the editors of the Brand Voice screen, by `widget`.
//
// Each per-tab plan registers the widget(s) its tab needs: v185 Principi → `pair_list`; v186 Esempi di stile →
// `str_list`; v187 Terminologia → `record_list`; v188 Claim verificati → `claims`; v189 Messaging → `scalar`.
// ⛔ Pick the editor by the payload's `widget` value, never by the data's shape (five
// fields arrive as a list of strings: one is pair_list, four are str_list).
//
// Contract: <Editor field value valueEn onChange onChangeEn disabled problems />
//   field     — the GET /document field (widget, policy, required, record_fields, claim_fields…)
//   value     — the draft IT value if any, else `fromWire(field, field.value)`: ⭐ ALWAYS the
//               EDITOR's shape (wireShape.js), e.g. Principi rows `{ name, description }`
//   valueEn   — bucket-D only: the draft EN value if any, else `fromWire(field, field.value_en)`
//   onChange(next) / onChangeEn(next) — hand up a WHOLE new value (immutable), editor shape
//   disabled  — AI update in progress or a save running
//   problems  — [{ key, params }] from validateField / a 422 (FieldRow renders the sentences;
//               an editor may use `params.row` to mark the offending row)
//   lang      — 'it' (default) | 'en': set by the bilingual wrapper (ui/BilingualColumns.jsx via
//               DocFields) when it mounts the SAME editor for the English half of a bucket-D field;
//               an editor uses it only to make its accessible labels distinct.
// ⛔ The "Personalità del brand" voice is NOT in this registry: it is a separate entity on its
// own route, not a document field, so it has its own form (ui/VoiceForm.jsx).
import ClaimsEditor from './ClaimsEditor.jsx';
import PairListEditor from './PairListEditor.jsx';
import RecordListEditor from './RecordListEditor.jsx';
import ScalarEditor from './ScalarEditor.jsx';
import StrListEditor from './StrListEditor.jsx';

export const WIDGET_EDITORS = {
  pair_list: PairListEditor,
  // ⭐ v186: also makes Messaging's key_messages / key_differentiators editable.
  str_list: StrListEditor,
  // ⭐ v187: terminology.preferred / .avoid, and also Messaging's taboo_claims.
  record_list: RecordListEditor,
  // ⭐ v188: verified_claims — five stacked categories, each a RecordListEditor.
  claims: ClaimsEditor,
  // ⭐ v189: messaging.positioning / .usp / .uvp — the last document fields.
  scalar: ScalarEditor,
};
